import { LocationDescriptor } from 'history';
import { CTA_RETURN_BACK } from 'mk/autogenerated/translations/NotFound.bec2af35be04d04f4aeba17a16ea79c1'
import { homepageUrl } from 'mk2/apps/home/urls';
import { NotFoundError } from 'mk2/components/errors/NotFoundError';
import { BackBtn } from 'mk2/components/BackBtn';
import { BtnLayout, BtnType } from 'mk2/components/Btn';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import styles from './NotFound.mscss';

interface OwnProps {
    backUrl?: LocationDescriptor;
}

type Props = OwnProps & RouteComponentProps<{}>;

export class NotFound extends React.Component<Props> {
    public render() {
        const { staticContext, backUrl } = this.props;

        if (staticContext && staticContext.statusCode === 200) {
            // ak este nikto nenastavil http error status (napr. 403 - Forbidden z @authOnly,
            // alebo 410 - Gone z render()) tak nastav 404 - Not Found
            staticContext.statusCode = 404;
        }

        return (
            <div className={styles.NotFound}>
                <NotFoundError
                    button={
                        <BackBtn
                            label={CTA_RETURN_BACK}
                            layout={BtnLayout.IconLabelCount}
                            link={backUrl ? backUrl : homepageUrl}
                            type={BtnType.Blue}
                        />
                    }
                />
            </div>
        );
    }
}
